define('lq/events/actions/scrollTo',[
    'lq/events/actions/eventAction',
    'jquery'
], function (EventAction, $) {
    'use strict';

    function ScrollTo(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ScrollTo, EventAction);

    ScrollTo.typeName = 'ScrollTo';

    ScrollTo.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
        
    ScrollTo.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
            
        var drop = self.piping.dropFactory.findDropByName(self.eventData.scrollTo);
        if (!drop)
            throw 'Cannot find drop : "' + self.eventData.timer + '" for scroll to event action.';
        if (drop.isVisible()) {
            this.piping.$actionWrapper.animate({
                scrollTop: drop.$element.offset().top
            }, {
                queue: false
            });
        }

        continuation();
    };

    return ScrollTo;
});
